import { AppCacheKeys } from 'src/types';
import { Application } from '../../features/common/types';
import { JOURNEY_NAME } from '../../features/common/types/tealium-service';

export const getJourneyNameFromSessionStorage = () => {
  const onboarding = JSON.parse(sessionStorage.getItem('onboarding') || '');

  const selfOnboarding: Application = onboarding[AppCacheKeys.selfOnboarding]?.item;
  const thirdParty: Application = onboarding[AppCacheKeys.thirdParty]?.item;
  const deviceActivation: Application = onboarding[AppCacheKeys.deviceActivation]?.item;

  const isPOSRevamp = !!(
    selfOnboarding &&
    !selfOnboarding.brokerLogin &&
    !selfOnboarding.agentJourney &&
    !selfOnboarding.pendingApp?.isPending
  );
  const is3rdParty = !!(thirdParty && (thirdParty.brokerLogin || thirdParty.agentJourney));
  const isDeviceActivation = !!(deviceActivation && deviceActivation.deviceActivationJourney);
  const isPendingApplication = !!(selfOnboarding && selfOnboarding.pendingApp?.isPending);
  const isOnboarding = !!(
    (selfOnboarding && !selfOnboarding.pendingApp?.isPending) ||
    (thirdParty && !thirdParty.pendingApp?.isPending) ||
    (deviceActivation && !deviceActivation.pendingApp?.isPending)
  );

  switch (true) {
    case isPOSRevamp:
      return JOURNEY_NAME.BUY_POS;
    case is3rdParty:
      return JOURNEY_NAME.THIRD_PARTY;
    case isDeviceActivation:
      return JOURNEY_NAME.DEVICE_ACTIVATION;
    case isPendingApplication:
      return JOURNEY_NAME.PENDING_APPLICATION;
    case isOnboarding:
      return JOURNEY_NAME.MERCHANT_ONBOARDING;
    default:
      return 'merchant portal';
  }
};
